import { Link } from 'react-router-dom';

export default function Footer() {
  const companyInfo = [
    { label: '会社名', value: '株式会社SUNFIELD' },
    { label: '所在地', value: '京都府京都市伏見区竹田藁屋町45 SOUBI BLD 2A' },
    { label: '営業所', value: '京都府八幡市戸津東代64−１' },
    { label: '電話', value: '090-9801-4659' },
    { label: 'メール', value: 'sunfield.53@gmail.com' },
    { label: '営業時間', value: '8:00〜17:00（土日定休）' }
  ];

  const quickLinks = [
    { name: 'ホーム', href: '/' },
    { name: '会社概要', href: '/about' },
    { name: 'サービス', href: '/services' },
    { name: '実績紹介', href: '/works' },
    { name: 'お客様の声', href: '/voice' },
    { name: 'ご依頼の流れ', href: '/flow' }
  ];

  const serviceLinks = [
    { name: '採用情報', href: '/recruit' },
    { name: '協力会社募集', href: '/partner' },
    { name: 'お知らせ', href: '/news' },
    { name: 'お問い合わせ', href: '/contact' }
  ];

  return (
    <footer className="bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* 会社情報 */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <div className="flex items-center space-x-4">
                <img 
                  src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/00223937c75469eb84420d444004ceb3.png" 
                  alt="Logo" 
                  className="h-12 w-48 object-contain"
                />
              </div>
              <p className="text-blue-200 leading-relaxed">
                安全・迅速・確実な輸送で社会に貢献し、お客様から信頼される物流パートナーを目指します。
              </p>
            </div>
            
            <div className="space-y-2">
              {companyInfo.map((info, index) => (
                <div key={index} className="flex">
                  <span className="w-20 text-blue-200 text-sm flex-shrink-0">{info.label}:</span>
                  <span className="text-white text-sm">{info.value}</span>
                </div>
              ))}
            </div>

            <div className="flex space-x-4 mt-6">
              <a
                href="https://www.instagram.com/sunfield.transport?igsh=cGpib2d6bzQzZTF5"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="mailto:sunfield.53@gmail.com"
                className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-mail-line text-xl"></i>
              </a>
              <a
                href="tel:090-9801-4659"
                className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* クイックリンク */}
          <div>
            <h3 className="text-lg font-bold mb-4">クイックリンク</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-blue-200 hover:text-white transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* サービス */}
          <div>
            <h3 className="text-lg font-bold mb-4">サービス</h3>
            <ul className="space-y-2">
              {serviceLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-blue-200 hover:text-white transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ボトムセクション */}
        <div className="border-t border-blue-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-blue-200 text-sm">
              © 2024 株式会社SUNFIELD All Rights Reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-200 hover:text-white transition-colors duration-200 text-sm cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
